import clsx from 'clsx';
import { singularOrPlural } from 'utils/common';
import styles from './QuantitySelector.module.css';

interface IQuantitySelectorProps {
  entryControlDisabled?: boolean;
  type: 'tree' | 'entry';
  quantity: number;
  min: number;
  max: number;
  setQuantity: (quantity: number) => void;
}

const QuantitySelector = ({
  entryControlDisabled,
  type,
  quantity,
  min,
  max,
  setQuantity,
}: IQuantitySelectorProps) => {
  const displayLabel = (quantity: number) => {
    switch (type) {
      case 'tree':
        return singularOrPlural(quantity, 'tree', 'trees');
      case 'entry':
        return singularOrPlural(quantity, 'entry', 'entries');
      default:
        return '';
    }
  };

  return (
    <div className={styles.quantitySelectorContainer}>
      <div
        className={clsx(`
                    ${styles.quantitySelectorBox} ${styles.quantitySelectorButton} ${!entryControlDisabled && min !== quantity ? styles.quantitySelectorEnabled : ''}
                `)}
        onClick={
          !entryControlDisabled && min !== quantity
            ? () => setQuantity(quantity - 1)
            : undefined
        }
      >
        -
      </div>
      <div
        className={`${styles.quantitySelectorBox} ${styles.quantitySelectorLabel}`}
      >
        {quantity} {displayLabel(quantity)}
      </div>
      <div
        aria-disabled={entryControlDisabled}
        className={`
                    ${styles.quantitySelectorBox} ${styles.quantitySelectorButton} ${!entryControlDisabled && max !== quantity ? styles.quantitySelectorEnabled : ''}`}
        onClick={
          !entryControlDisabled && max !== quantity
            ? () => setQuantity(quantity + 1)
            : undefined
        }
      >
        +
      </div>
    </div>
  );
};

export default QuantitySelector;
